module.exports = __webpack_public_path__ + "static/media/segoe-ui.c4b43d1f.ttf";